import { EditorState } from 'editor/src/store/editor/types';

const resetSettingsToDefaultReducer = (state: EditorState) => {
  state.settings = state.defaultSettings;
};

export default resetSettingsToDefaultReducer;
